import { createSlice,PayloadAction } from '@reduxjs/toolkit';
import { AppDispatch } from './index';


const initialState: any = {
    settings: null,
};
const onboardAndExitReviewSlice = createSlice({
    name: 'onboardAndExitReview',
    initialState,
    reducers: {
        setOnboardAndExitReviewSlice(state, action: PayloadAction<any>) {
            state.settings = action.payload;
        },
    },
});

export const getonboardAndExitReviewSettings = (data: boolean) => {
    return async (dispatch: AppDispatch) => {
        try {
            // const response = await fetch('/onboarding-exit-reviews.json');
            // const data = await response.json();
            // await dispatch(onboardAndExitReviewSlice.actions.setOnboardAndExitReviewSlice(data));
            dispatch(onboardAndExitReviewSlice.actions.setOnboardAndExitReviewSlice(data));
        } catch (err) {
            console.log('error from onboardAndExitReviewSlice', err);
        }
    };
};

export default onboardAndExitReviewSlice.reducer;
export const { setOnboardAndExitReviewSlice } = onboardAndExitReviewSlice.actions;
